// dashboard-servicerequest.actions.ts
import { MenuAction } from '@shared/interfaces/header/menu-action';
import { dashboardActionMenu } from '@views/dashboard/list-views/util/dashboard.action-menu';
import { UserResponse } from '@app/api/dmc';

export type ActionType = 'reply' | 'complete' | 'completeSimple' | 'list' | 'remove';

export interface ActionCallbacks {
  getSelectedElements: () => any[];
  openReplyModal?: () => void;
  openCompleteModal?: () => void;
  openListModal?: () => void;
  openRemoveModal?: () => void;
}

export function createActions(
  callbacks: ActionCallbacks,
  enabledActions: ActionType[]
): MenuAction[] {
  const actionMap: Record<ActionType, MenuAction> = {
    reply: {
      ...dashboardActionMenu[0],
      callback: callbacks.openReplyModal,
      disabled: () => {
        const selected = callbacks.getSelectedElements();
        return selected.length !== 1 || selected[0].isCancelledBySupplier === true || selected[0].userResponse === UserResponse.Approved || selected[0].userResponse === UserResponse.ManuallyHandled;
      }
    },
    complete: {
      ...dashboardActionMenu[1],
      callback: callbacks.openCompleteModal,
      disabled: () => {
        const selected = callbacks.getSelectedElements();
        return !(selected.length === 1 &&
          selected[0].isCancelledBySupplier !== true &&
          (selected[0].userResponse === UserResponse.Approved ||
            selected[0].userResponse === UserResponse.ManuallyHandled ||
            selected[0].userResponse === UserResponse.NotRequired));
      }
    },
    completeSimple: {
      ...dashboardActionMenu[1],
      callback: callbacks.openCompleteModal,
      disabled: () => {
        const selected = callbacks.getSelectedElements();
        return selected.length !== 1 || selected[0].isCancelledBySupplier === true;
      },
    },
    list: {
      ...dashboardActionMenu[2],
      callback: callbacks.openListModal,
      breaker: true,
    },
    remove: {
      ...dashboardActionMenu[3],
      callback: callbacks.openRemoveModal,
      disabled: () => {
        const selected = callbacks.getSelectedElements();
        return !(selected.length === 1 && selected[0].isCancelledBySupplier === true);
      },
      breaker: true,
    },
  };

  return enabledActions.map(action => actionMap[action]);
}
